export const SUPPORTED_LANGUAGES = ['ru', 'en', 'es'];

export function resolveLanguage(mount) {
  const queryLanguage = new URLSearchParams(window.location.search).get('lang');
  const mountLanguage = mount?.dataset?.lang;
  const documentLanguage = document.documentElement.lang;
  const storedLanguage = window.localStorage.getItem('interactive-book:lang');

  const candidate = [
    queryLanguage,
    mountLanguage,
    documentLanguage,
    storedLanguage,
    'ru'
  ]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase().split('-')[0])
    .find((value) => SUPPORTED_LANGUAGES.includes(value));

  return candidate ?? 'ru';
}

export function persistLanguage(language) {
  if (SUPPORTED_LANGUAGES.includes(language)) {
    window.localStorage.setItem('interactive-book:lang', language);
  }
}

export function getLanguageLinks(mount) {
  const localFallback = Object.fromEntries(
    SUPPORTED_LANGUAGES.map((language) => [language, `/?lang=${language}`])
  );

  if (!mount) return localFallback;

  return {
    ru: mount.dataset.langRu || localFallback.ru,
    en: mount.dataset.langEn || localFallback.en,
    es: mount.dataset.langEs || localFallback.es
  };
}

/**
 * Where the studio wordmark points. The book is one page of a site, and this
 * is the only way back into it — the page carries no site chrome on purpose.
 * `data-home` on the mount so the page owns the URL, exactly like the locale
 * links; the fallback is only for local development.
 */
export function getHomeLink(mount) {
  return mount?.dataset?.home || 'https://bureauinsight.com/';
}

export const UI_LABELS = {
  ru: {
    previous: 'Предыдущая страница',
    next: 'Следующая страница',
    reader: 'Читать без эффектов',
    book: 'Режим книги',
    soundOn: 'Включить звук листания',
    soundOff: 'Выключить звук листания',
    musicOn: 'Включить музыку',
    musicOff: 'Выключить музыку',
    progress: 'Страница',
    zoomHint: 'Нажмите на книгу, чтобы приблизить колесом',
    textMode: 'Текст',
    openBook: 'Открыть книгу',
    home: 'INSIGHT ADB — на главную'
  },
  en: {
    previous: 'Previous page',
    next: 'Next page',
    reader: 'Read without effects',
    book: 'Book mode',
    soundOn: 'Enable page sound',
    soundOff: 'Disable page sound',
    musicOn: 'Enable music',
    musicOff: 'Disable music',
    progress: 'Page',
    zoomHint: 'Click the book to zoom with the wheel',
    textMode: 'Text',
    openBook: 'Open the book',
    home: 'INSIGHT ADB — home page'
  },
  es: {
    previous: 'Página anterior',
    next: 'Página siguiente',
    reader: 'Leer sin efectos',
    book: 'Modo libro',
    soundOn: 'Activar sonido de página',
    soundOff: 'Desactivar sonido de página',
    musicOn: 'Activar música',
    musicOff: 'Desactivar música',
    progress: 'Página',
    zoomHint: 'Haga clic en el libro para acercar con la rueda',
    textMode: 'Texto',
    openBook: 'Abrir el libro',
    home: 'INSIGHT ADB — página principal'
  }
};
